import CryptoJS from 'crypto-js';

const merchant_key = 'smsplus';
const merchant_secret = 'izF09TlpX4ZOwmf9MvXijwYsBPUmxYHD';

function getAuthHeader(requestData) {
    const AUTH_TYPE = 'sha512';
    const date = new Date().toUTCString();
    const data = requestData ? JSON.stringify(requestData) : "";
    const hash_string = data + '|' + date + '|' + merchant_secret;
    const hash = CryptoJS.SHA512(hash_string).toString(CryptoJS.enc.Hex);
    
    return {
        date: date,
        authorization: `hmac username="${merchant_key}", algorithm="${AUTH_TYPE}", headers="date", signature="${hash}"`
    };
}

export { getAuthHeader };
